import { IUserService } from '@public/service/ports';
import {
  accountHasPlatCard,
  addContactsMethod,
  getContractInfo,
  getRsaMyCards,
  getUserSignInfo,
  getUserSmInfo,
  IAddContactOptions,
  IGetRsaMyCardsOptions,
} from '@public/api/user';
import { IAES } from '@common/utils/EAS';

export function userService(): IUserService {
  const getAyhContract = async () => getContractInfo();

  const getUserInfo = async () =>
    getUserSmInfo(
      {},
      {
        hasLoad: false,
        ignoreError: true,
      },
    );

  const querySignInfo = async () => getUserSignInfo();

  const getMyAllCards = async (params: IGetRsaMyCardsOptions, aes: IAES) =>
    getRsaMyCards(params, aes);

  const addContacts = async (options: IAddContactOptions) => addContactsMethod(options);

  const checkHasPlatCard = async (options: any) => accountHasPlatCard(options);

  return {
    getAyhContract,
    getUserInfo,
    addContacts,
    getPaySign: querySignInfo,
    getUserBankCards: getMyAllCards,
    checkHasPlatCard,
  };
}
